import ChangeMethodModal from 'components/RwdBasket/Carts/CartLayout/SkuItem/ChangeMethod/ChangeMethodModal/ChangeMethodModal';
import { withRewardFulfillmentMethodModalProps } from 'viewModel/rewardFulfillmentMethodModal/withRewardFulfillmentMethodModalProps';

export default withRewardFulfillmentMethodModalProps(ChangeMethodModal);
